// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGAttach = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  children: [/*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("path", {
      d: "M16.233 8.738c.564-.502.564-1.317 0-1.818-.564-.503-1.477-.503-2.04 0l-7.128 6.35c-1.374 1.223-1.374 3.213 0 4.436.686.612 1.587.918 2.49.918.9 0 1.802-.306 2.489-.918l10.318-9.193h.001c2.183-1.946 2.183-5.11 0-7.055-2.181-1.944-5.733-1.944-7.918 0l-12.2 10.87c-2.993 2.667-2.993 7.006 0 9.673C3.742 23.334 5.707 24 7.673 24c1.965 0 3.93-.666 5.427-2l9.01-8.027c.563-.501.563-1.316 0-1.818-.564-.503-1.478-.503-2.042 0l-9.009 8.027c-1.867 1.664-4.906 1.663-6.773 0-1.867-1.664-1.867-4.37 0-6.035l12.2-10.869c1.058-.944 2.779-.943 3.836-.001s1.057 2.475 0 3.417h-.002l-10.317 9.194c-.249.22-.651.22-.897 0-.248-.22-.248-.58 0-.8l7.127-6.35z",
      id: "attach__a"
    })
  }), /*#__PURE__*/_jsx("use", {
    xlinkHref: "#attach__a",
    fillRule: "evenodd"
  })]
}));
SVGAttach.displayName = 'SVGAttach';
export default SVGAttach;